export default "skymp5-front/7b96a4a6104c59cc93f2be8ee49396ab.png";